(function () {
  var CUSTOMER_PARAM = 'customer_posted';
  var SUCCESS_FLAG = 'the4:newsletterSuccess';
  var COPY_SELECTOR = '[data-newsletter-copy]';
  var CODE_SELECTOR = '[data-newsletter-code]';
  var SUCCESS_SELECTOR = '[data-newsletter-success]';
  var hasOpened = false;

  document.addEventListener('the4:recentform', handleRecentForm, true);
  document.addEventListener('DOMContentLoaded', function () {
    attachModalListeners();
    if (shouldOpenFromQuery()) {
      if (!openFromRecentForm()) {
        openFromInlineSuccess();
      }
    }
  });
  document.addEventListener('click', handleCopyClick);

  function handleRecentForm(event) {
    if (!event || !event.detail || !event.detail.recentform) {
      return;
    }
    var form = document.getElementById(event.detail.recentform);
    if (!isNewsletterForm(form)) {
      return;
    }
    sessionStorage.setItem(SUCCESS_FLAG, 'true');
    var instance = findInstanceForForm(form) || getPrimaryInstance();
    if (!instance) {
      return;
    }
    openInstance(instance);
  }

  function openFromRecentForm() {
    var recentFormId = sessionStorage.getItem('the4:recentform');
    if (!recentFormId) {
      return false;
    }
    var form = document.getElementById(recentFormId);
    if (!isNewsletterForm(form)) {
      return false;
    }
    var instance = findInstanceForForm(form) || getPrimaryInstance();
    if (!instance) {
      return false;
    }
    openInstance(instance);
    return true;
  }

  function openFromInlineSuccess() {
    var inlineSuccess = document.querySelector(SUCCESS_SELECTOR);
    if (!inlineSuccess) {
      return false;
    }
    var instance = getPrimaryInstance();
    if (!instance) {
      return false;
    }
    openInstance(instance);
    return true;
  }

  function openInstance(instance) {
    if (!instance || hasOpened) {
      return false;
    }
    var hasSuccess = hasSuccessContent(instance);
    applySuccessState(instance, hasSuccess);
    hasOpened = true;
    resetCopyButtons(instance.host || instance.modal || document);
    if (instance.modal && typeof instance.modal.open === 'function') {
      instance.modal.open();
    } else if (instance.dialog && typeof instance.dialog.showModal === 'function') {
      instance.dialog.showModal();
    }
    sessionStorage.setItem(SUCCESS_FLAG, 'true');
    if (hasSuccess) {
      reportNewsletterOutcome(instance);
    }
    return true;
  }

  function attachModalListeners() {
    getInstances().forEach(function (instance) {
      if (!instance.dialog) {
        return;
      }
      instance.dialog.addEventListener('close', cleanup);
      instance.dialog.addEventListener('cancel', cleanup);
    });
  }

  function cleanup(event) {
    var host = event && event.target ? event.target.closest('sys-newsletter') : null;
    if (host) {
      applySuccessState(buildInstance(host), false);
    }
    hasOpened = false;
    removeQueryParameter(CUSTOMER_PARAM);
    sessionStorage.removeItem(SUCCESS_FLAG);
    resetCopyButtons(event && event.target ? event.target : document);
  }

  function handleCopyClick(event) {
    var button = event.target.closest(COPY_SELECTOR);
    if (!button) {
      return;
    }
    event.preventDefault();
    if (!button.hasAttribute('data-original-label')) {
      button.setAttribute('data-original-label', getButtonLabel(button));
    }
    var codeField = findCodeField(button);
    var codeValue = codeField ? getCodeValue(codeField) : '';
    if (!codeValue) {
      return;
    }
    copyText(codeValue, codeField).then(function () {
      updateButtonAfterCopy(button);
      closeRelatedModal(button);
    }).catch(function () {
      updateButtonAfterCopy(button);
      closeRelatedModal(button);
    });
  }

  function findCodeField(button) {
    var container = button.closest(SUCCESS_SELECTOR) || document;
    return container.querySelector(CODE_SELECTOR);
  }

  function getCodeValue(field) {
    if (!field) {
      return '';
    }
    var value = '';
    if ('value' in field) {
      value = field.value;
    } else {
      value = field.textContent || '';
    }
    return value.trim();
  }

  function updateButtonAfterCopy(button) {
    var copiedLabel = button.getAttribute('data-copied-label');
    if (!copiedLabel) {
      return;
    }
    var target = button.querySelector('span');
    if (target) {
      target.textContent = copiedLabel;
    } else {
      button.textContent = copiedLabel;
    }
  }

  function resetCopyButtons(context) {
    var scope = context && typeof context.querySelectorAll === 'function' ? context : document;
    scope.querySelectorAll(COPY_SELECTOR).forEach(function (button) {
      var original = button.getAttribute('data-original-label');
      if (!original) {
        original = getButtonLabel(button);
        button.setAttribute('data-original-label', original);
        return;
      }
      var target = button.querySelector('span');
      if (target) {
        target.textContent = original;
      } else {
        button.textContent = original;
      }
    });
  }

  function closeRelatedModal(button) {
    var modal = button.closest('hdt-modal');
    var dialog = button.closest('dialog');
    if (modal && typeof modal.close === 'function') {
      modal.close();
    } else if (dialog && typeof dialog.close === 'function') {
      dialog.close();
    }
  }

  function getInstances() {
    return Array.prototype.slice.call(document.querySelectorAll('sys-newsletter')).map(buildInstance).filter(Boolean);
  }

  function getPrimaryInstance() {
    var host = document.querySelector('sys-newsletter');
    return host ? buildInstance(host) : null;
  }

  function findInstanceForForm(form) {
    if (!form) {
      return null;
    }
    var host = form.closest('sys-newsletter');
    if (host) {
      return buildInstance(host);
    }
    var targetId = form.getAttribute('data-id');
    if (targetId) {
      var dialog = document.getElementById(targetId);
      if (dialog) {
        host = dialog.closest('sys-newsletter');
        if (host) {
          return buildInstance(host);
        }
      }
    }
    return null;
  }

  function buildInstance(host) {
    if (!host) {
      return null;
    }
    var modal = host.querySelector('hdt-modal');
    var dialog = host.querySelector('dialog');
    if (!modal || !dialog) {
      return null;
    }
    return { host: host, modal: modal, dialog: dialog };
  }

  function reportNewsletterOutcome(instance) {
    if (!instance || !instance.host) {
      return;
    }
    instance.host.dispatchEvent(new CustomEvent('hdt:newsletter:outcome', {
      bubbles: true,
      detail: { outcome: 'subscribed' }
    }));
  }

  function isNewsletterForm(form) {
    return form && form.classList && form.classList.contains('hdt-newsletter__form');
  }

  function shouldOpenFromQuery() {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get(CUSTOMER_PARAM) === 'true';
    } catch (error) {
      return false;
    }
  }

  function removeQueryParameter(param) {
    if (!param) {
      return;
    }
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has(param)) {
        return;
      }
      url.searchParams.delete(param);
      var newSearch = url.searchParams.toString();
      var newUrl = url.pathname + (newSearch ? '?' + newSearch : '') + url.hash;
      window.history.replaceState({}, document.title, newUrl);
    } catch (error) {
      /* noop */
    }
  }

  function copyText(text, inputElement) {
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      if (!inputElement) {
        reject();
        return;
      }
      if (typeof inputElement.focus === 'function') {
        inputElement.focus();
      }
      if (typeof inputElement.select === 'function') {
        inputElement.select();
      }
      if (typeof inputElement.setSelectionRange === 'function') {
        inputElement.setSelectionRange(0, text.length);
      }
      var succeeded = false;
      try {
        succeeded = document.execCommand('copy');
      } catch (error) {
        succeeded = false;
      }
      if (window.getSelection) {
        var selection = window.getSelection();
        if (selection && selection.removeAllRanges) {
          selection.removeAllRanges();
        }
      }
      if (succeeded) {
        resolve();
      } else {
        reject();
      }
    });
  }

  function getButtonLabel(button) {
    if (!button) {
      return '';
    }
    var span = button.querySelector('span');
    if (span) {
      return span.textContent || '';
    }
    return button.textContent || '';
  }

  function hasSuccessContent(instance) {
    if (!instance) {
      return false;
    }
    var scope = instance.host || instance.modal || instance.dialog;
    if (!scope || typeof scope.querySelector !== 'function') {
      return false;
    }
    return Boolean(scope.querySelector(SUCCESS_SELECTOR));
  }

  function applySuccessState(instance, active) {
    if (!instance) {
      return;
    }
    var scope = instance.host || instance.modal || instance.dialog;
    if (!scope || typeof scope.querySelector !== 'function') {
      return;
    }
    var content = scope.querySelector('.hdt-content');
    if (content && content.children) {
      Array.prototype.forEach.call(content.children, function (child) {
        if (child.classList && child.classList.contains('hdt-newsletter')) {
          return;
        }
        toggleHidden(child, active);
      });
    }
    var newsletter = scope.querySelector('.hdt-newsletter');
    if (newsletter) {
      toggleHidden(newsletter.querySelector('.hdt-newsletter__fields'), active);
      var response = newsletter.querySelector('.hdt-newsletter__response');
      if (response) {
        toggleHidden(response, false);
      }
    }
    var success = scope.querySelector(SUCCESS_SELECTOR);
    if (success) {
      success.removeAttribute('hidden');
      success.removeAttribute('aria-hidden');
    }
  }

  function toggleHidden(element, shouldHide) {
    if (!element) {
      return;
    }
    if (shouldHide) {
      element.setAttribute('data-newsletter-hidden', 'true');
      element.setAttribute('hidden', '');
    } else if (element.getAttribute('data-newsletter-hidden') === 'true') {
      element.removeAttribute('hidden');
      element.removeAttribute('data-newsletter-hidden');
    }
  }
})();
